export default {
  pdPeriod: {
    column: {
      projectName: '项目名称',
      periodName: '账期名称',
      startDate: '日期从',
      endDate: '日期至',
      periodStatus: '账期状态',
    },
    placeholder: {
      projectName: '请选择项目名称',
      periodName: '请输入账期名称',
      startDate: '请输入日期从',
      endDate: '请输入日期至',
      auto: '自动生成',
    },
    message: {
      select: '请选择一条数据操作，或直接点击行数据编辑',
      cannotOpen: '所选数据中没有已关闭状态，请重新选择！',
      cannotClose: '所选数据中没有已打开状态，请重新选择！',
      hasCannotOpen: '所选数据中有不可打开的数据，点击确认只会打开已关闭状态的数据！',
      hasCannotClose: '所选数据中有不可关闭的数据，点击确认只会关闭已打开状态的数据！',
      isOpenConfirm: '是否确认打开？',
      isCloseConfirm: '是否确认关闭？',
    },
  },
};
